import URLConst from '../constants/URLConst';
import { fetchJSON, secureGET, securePOST, securePUT, secureDELETE, withQuery } from '../utilities/FetchHelper';
class HotelContentService {
    getHotelContents(data) {
        let url = URLConst.HOTEL_ONBOARDING_SERVICE + URLConst.PATH_HOTEL_CONTENT
        for (const key in data) {
            url = url.replace('{' + key + '}', data[key])
        }
        if (data.queryParams) {
            url = withQuery(url, data.queryParams)
        }
        return fetchJSON(url, secureGET()).then(response => {
            return response
        }).catch((error) => {
            throw error
        })
    }
    
    putHotelContent(data) {
        let url = URLConst.HOTEL_ONBOARDING_SERVICE + URLConst.PATH_HOTEL_CONTENT
        for (const key in data) {
            url = url.replace('{' + key + '}', data[key])
        }
        const formData = data.formData
        return fetchJSON(url, { ...securePUT(), body: JSON.stringify(formData) }).then(response => {
            return response
        }).catch((error) => {
            throw error
        })
    }
    
    deleteHotelContent(data) {
        let url = URLConst.HOTEL_ONBOARDING_SERVICE + URLConst.PATH_HOTEL_CONTENT
        for (const key in data) {
            url = url.replace('{' + key + '}', data[key])
        }
        const formData = data.formData
        url = url + "/" + formData.contentId;
        return fetchJSON(url, { ...secureDELETE(), body: JSON.stringify(formData) }).then(response => {
            return response
        }).catch((error) => {
            throw error
        })
    }
}
export default new HotelContentService()